import { reportcustomerconstants } from "../constants/reportcustomerConstants"

export const getreportcustomer = (pageNo, filterData) => {
    return {
        type: reportcustomerconstants.GET_REPORT_CUSTOMER,
        pageNo,
        filterData
    }
}
